import { flushSetUpdates, supabaseWorkoutRepository } from '@features/workouts';

/**
 * Wires the offline-queue flusher into the runtime:
 *  - on tab focus and `online` events: try to drain the queue
 *  - every 30s while online: opportunistic retry
 *
 * Idempotent: the worker has its own in-flight guard.
 */
export function startSyncBootstrap(): void {
  const flush = (): void => {
    if (!navigator.onLine) return;
    void flushSetUpdates(supabaseWorkoutRepository);
  };

  // Initial drain on app start.
  flush();

  window.addEventListener('online', flush);
  window.addEventListener('focus', flush);

  // Background poll. 30s is gentle enough for battery and aggressive enough
  // that a flaky connection re-syncs within a typical between-set rest.
  window.setInterval(flush, 30_000);
}
